<template>
    <v-runtime-template :template="DseLinkTemplate" />
</template>

<script>
    import VRuntimeTemplate from "v-runtime-template";    

    export default {
        computed: {
            Strings() {
                return this.$migrolVueLibraryData.Strings;
            },
            Settings() {
                return this.$migrolVueLibraryData.Settings;
            },
            DseLinkTemplate() {
                //WWW-2163 - replaced DSECheckbox with DSESentence
                //return this.Strings['Global.AGBDSE.DSECheckbox'];
                return this.Strings['Global.AGBDSE.DSESentence'];
            },
            DseLink() {
                return this.Settings['dseUrl'];
            }
        },
        components: {
            VRuntimeTemplate
        }
    };
</script>